// 1 ) Objeto que se va guardar en el contexto 

const initialState = {
    CfgConfigId: "",
    ComCompanyId: "",
    ComName: "",
    CfgNavBarColor: "",
    CfgNavLineColor: "",
    CfgNavTextColor: "",
    CfgNavIconColor: "",
    CfgNavIconBG: "",
    CfgImgBGDesktop: "",
    CfgImgBGMovil: "",
    LogoLimitless: "S",
    LogoLimitlessMovil: "S"
};

// 2 ) Logica de manejo de la variable 
const companyReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ESTABLECER_COMPANY":
            return {
                ...state,
                CfgConfigId: action.CfgConfigId,
                ComCompanyId: action.ComCompanyId,
                ComName: action.ComName,
                CfgNavBarColor: action.CfgNavBarColor,
                CfgNavLineColor: action.CfgNavLineColor,
                CfgNavTextColor: action.CfgNavTextColor,
                CfgNavIconColor: action.CfgNavIconColor,
                CfgNavIconBG: action.CfgNavIconBG,
                CfgImgBGDesktop: action.CfgImgBGDesktop,
                CfgImgBGMovil: action.CfgImgBGMovil,
                LogoLimitless: action.LogoLimitless,
                LogoLimitlessMovil: action.LogoLimitlessMovil
            }
        default: return state;
    }
};

//3 se exporta el comporamiento que administra la variable pra poder usarse 

export default companyReducer;